import React from 'react'
import { NavbarStyle } from '../../utilities/styles'
import { Link } from 'gatsby'
import { StaticImage } from 'gatsby-plugin-image'
import { Box, HStack, IconButton, Spacer } from '@chakra-ui/react'
import { FiMenu } from '@react-icons/all-files/fi/FiMenu'
import { FiX } from '@react-icons/all-files/fi/FiX'

export default function HorizontalNav({ 
  openMenu, 
  handleOpenMenu, 
  colorMode, 
  bgColor 
}) {

  return (
    <HStack 
      bg={NavbarStyle.Bg()}
      height="58px"
      borderBottom="1px" 
      display={['flex', , 'none']} 
    >
      <Box p="2" my="2">
        <Link to="/">
          {
            colorMode === 'light' 
            ? <StaticImage src="../../images/jomweb-small-white.png" alt="Jomweb" height={40} /> 
            : <StaticImage src="../../images/jomweb-small-black.png" alt="Jomweb" height={40} />
          }
        </Link>
      </Box>
      <Spacer/>
      <Box p="2" borderLeft="1px">
        { openMenu 
          ? (
            <IconButton 
              icon={<FiX fontSize="26" />} 
              variant="ghost"
              onClick={() => handleOpenMenu(false)}
            />
          )
          : (
            <IconButton 
              icon={<FiMenu fontSize="26" />} 
              variant="ghost"
              onClick={() => handleOpenMenu(true)}
            />
          ) 
        }
      </Box>
    </HStack>
  )
}
